import { render, staticRenderFns } from "./MyCard.vue?vue&type=template&id=59c974dc&scoped=true"
import script from "./MyCard.vue?vue&type=script&lang=js"
export * from "./MyCard.vue?vue&type=script&lang=js"
import style0 from "./MyCard.vue?vue&type=style&index=0&id=59c974dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c974dc",
  null
  
)

export default component.exports